import ArrowRightIcon from "@/assets/colorable/right_arrow.svg?react";
import {useHelpUrl} from "@/hooks/useNavigationHooks";
import HdlLogo from "@/images/HdL_Buch-Tag.png";
import RefluencedLogo from "@/images/Refluenced_Logo_Gradient_Neg.svg";
import VentureKickLogo from "@/images/Venture_Kick_Logo.png";
import {Can} from "@/permissions";
import {useMemo, type FC} from "react";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router";

const DONT_SHOW_FOR_PAGES = ["/chat"] as const;

const Footer: FC = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const helpUrl = useHelpUrl();

  const shouldHideFooter = useMemo(() => {
    return DONT_SHOW_FOR_PAGES.some(page => location.pathname.includes(page));
  }, [location.pathname]);

  if (shouldHideFooter) return <></>;

  return (
    <footer className="bg-good-grey-900 font-roboto pt-20 pb-12">
      <div className="container mx-auto flex flex-col gap-12 px-8">
        <div className="grid grid-cols-2 gap-x-12 gap-y-8 md:grid-cols-3 lg:grid-cols-4">
          <div className="flex flex-col items-center gap-4 md:items-start">
            <span className="text-2xl text-white">{t("Sitemap")}</span>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/?landing"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("forBrands")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/for-agencies/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("forAgencies")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/for-influencers/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("forInfluencers")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/plans/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("Prices")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/blog/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("Blog")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href={helpUrl}
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("Help & FAQ")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/about/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("aboutUs")}
            </a>
          </div>
          <div className="flex flex-col items-center gap-4 md:items-start">
            <span className="text-2xl text-white">{t("More")}</span>
            <a
              style={{
                textDecoration: "none",
              }}
              target="_blank"
              href="https://www.instagram.com/refluenced/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("Instagram")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              target="_blank"
              href="https://www.linkedin.com/company/refluenced/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("LinkedIn")}
            </a>
            <Can I="create" a="MailToSupport">
              <a
                style={{
                  textDecoration: "none",
                }}
                href={`mailto:info@refluenced.com`}
                className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
                {t("Email ")}
              </a>
            </Can>
          </div>
          <div className="flex flex-col items-center gap-4 md:items-start">
            <span className="text-2xl text-white">{t("legal")}</span>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/legal/cookie-policy/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("cookiePolicy")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/legal/impressum/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("imprint")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/legal/privacy-policy/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("privacy_policy")}
            </a>
            <a
              style={{
                textDecoration: "none",
              }}
              href="/legal/toc/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white transition-all duration-150">
              {t("ToS")}
            </a>
          </div>
          <div className="col-span-2 flex w-full flex-row flex-wrap items-center justify-between gap-10 md:col-span-3 md:gap-20 lg:col-span-1 lg:flex-col lg:items-end lg:justify-start lg:gap-10">
            <img src={VentureKickLogo} alt="" className="h-10 shrink-0" />
            <img src={HdlLogo} alt="" className="h-14 shrink-0" />
            <img src={RefluencedLogo} alt="" className="h-10 shrink-0" />
          </div>
        </div>
        <div className="flex flex-wrap justify-between gap-8">
          <span className="text-neutral-white-dark text-sm whitespace-nowrap">{t("refluencedCopyright")}</span>
          <button
            onClick={() =>
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              })
            }
            className="flex gap-4">
            <ArrowRightIcon className="text-neutral-white-dark h-4 -rotate-90" />
            <span className="text-neutral-white-dark text-sm whitespace-nowrap">{t("backToTop")}</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
